import service from '@/utils/request'


/**
 * 获取新闻列表
 * @param {number} page - 页码
 * @param {number} limit - 每页数量
 * @returns {Promise}
 */
export function getNewsPage(page = 1, limit = 10) {
  return service({
    url: '/api/news/page',
    method: 'get',
    params: { page, limit }
  })
}
/**
 * 获取新闻列表
 */
export function getNewsList() {
  return service({
    url: '/api/news/getNewsList',
    method: 'get'
  })
}

/**
 * 获取新闻详情
 * @param {number} id - 新闻 ID
 * @returns {Promise}
 */
export function getNewsDetail(id) {
  return service({
    url: `/api/news/${id}`,
    method: 'get'
  })
}

